// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';


import './assets/css/reset.css'
import './assets/css/reset2.css'
import VueCookies from './utils/vueCookie'
import Pagination from "@/components/Pagination";


Vue.component('Pagination', Pagination);
Vue.prototype.$layer = layer(Vue);
Vue.use(ElementUI);


Vue.prototype.$cookies = VueCookies;

Vue.prototype.msgSuccess = function (msg) {
  this.$message({showClose: true, message: msg, type: "success"});
}

Vue.prototype.msgError = function (msg) {
  this.$message({showClose: true, message: msg, type: "error"});
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}
//时间转换（去掉T）
Vue.prototype.transformTime = function (time) {
  let dateee = new Date(time).toJSON();
  return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
}
Vue.config.productionTip = false
Vue.component('Pagination', Pagination)

//显示页面标题
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  document.title = '用户中心-'+to.name;
  // }
  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js